'use client'

import { PaymentElement } from '@stripe/react-stripe-js'
import { usePaymentStore } from '../store'

export const StripeForm = () => {
  const { setPending, setError, setValid } = usePaymentStore()

  return (
    <PaymentElement
      onReady={() => setPending(false)}
      onChange={e => {
        setError('')
        setValid(e.complete)
      }}
      onLoadError={() => setPending(false)}
      onLoaderStart={() => setPending(true)}
    />
  )
}
